import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Button, Typography, Modal, message, Menu, Dropdown, Space, Divider, Image, Spin } from 'antd';
import { InboxOutlined, UserOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { updateTalentSearchRequests } from '../../actions/TalentSearchActions';
import ProgressiveImage from '../common/ProgressiveImage';
import dayjs from "dayjs";

const { Title, Text } = Typography;

const TalentSearchRequests = () => {
  const dispatch = useDispatch();

  const { requests, loading, error } = useSelector(state => state.talentSearch);

  const [visible, setVisible] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [filteredRequests, setFilteredRequests] = useState();
  const [filter, setFilter] = useState('new');

     useEffect(() => {
            window.scrollTo(0, 0);
        }, []);

  useEffect(() => {
    handleFilterChange();
  }, [requests, filter]);


  // Handle updating the request status
  const handleUpdateStatus = (requestId, status) => {
    dispatch(updateTalentSearchRequests(requestId, status));
  };
  // onClick={() => handleUpdateStatus(request.id, 'Approved')}


  const openModal = (request) => {
    setSelectedRequest(request);
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const handleApprove = () => {
    // message.success('Request approved');
    setVisible(false);
    handleUpdateStatus(selectedRequest.id, 'approved');
  };

  const handleReject = () => {
    // message.error('Request rejected');
    setVisible(false);
    handleUpdateStatus(selectedRequest.id, 'rejected');
  };

  // const updateRequestStatus = (id, status) => {
  //   const updatedRequests = filteredRequests.map((request) =>
  //     request.id === id ? { ...request, status } : request
  //   );
  //   setFilteredRequests(updatedRequests);
  // };

  const handleFilterChange = () => {
    // if (filter === 'all') {
    //   setFilteredRequests(requests);
    // } else {
      const filtered = requests.filter((request) => request.status === filter);
      setFilteredRequests(filtered);
    // }
  };

  const handlePlayMedia = (url, type) => {
    if (type === 'audio' || type === 'video') {
      window.open(url, '_blank');
    } else {
      // const audio = new Audio(url);
      // audio.play();
      message.error("Can't understand the type of media uploaded. Download instead!")
    }
  };

  const handleDownloadMedia = (file) => {
    const url = file.url;
    const title = file.title;

    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.download = title;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);


    // const url = file.url;
    // const title = file.title;

    // const response =  fetch(url, {
    //   method: 'GET',
    //   mode: 'cors', // Ensure CORS is enabled
    // });

    // if (!response.ok) {
    //   throw new Error(`HTTP error! Status: ${response.status}`);
    // }

    // fetch(url)
    //   .then((response) => response.blob()) // Fetch the file as a Blob
    //   .then((blob) => {
    //     const blobUrl = window.URL.createObjectURL(new Blob([blob]));
    //     const downloadLink = document.createElement('a');
    //     downloadLink.href = blobUrl;
    //     downloadLink.download = title;
    //     document.body.appendChild(downloadLink);
    //     downloadLink.click();
    //     document.body.removeChild(downloadLink);
    //   })
    //   .catch((error) => {
    //     console.error('Download failed:', error);
    //   });

  };

  const handlePlayRecording = (url) => {
    // const audio = new Audio(url);
    // audio.play();
    window.open(url, '_blank');

  };

  const handleDownloadRecording = (file) => {
    const url = file.url;
    const title = file.title;

    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.download = title;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <div style={{ padding: '20px', backgroundColor: '#f5f5f5',minHeight: "100vh" }}>
      {/* <Title level={2} style={{ color: '#059941', textAlign: 'center' }}>
        Recruitment Requests
      </Title> */}

      {/* Menu for filtering requests */}
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <Menu
          onClick={(e) => setFilter(e.key)}
          selectedKeys={[filter]}
          mode="horizontal"
          style={{ justifyContent: 'center', border: '1px solid var(--primary)' }}
        >
          {/* <Menu.Item key="all">All</Menu.Item> */}
          <Menu.Item key="new">New</Menu.Item>
          <Menu.Item key="approved">Approved</Menu.Item>
          <Menu.Item key="rejected">Rejected</Menu.Item>
        </Menu>
      </div>

      {
     loading
     ?
     <Spin style={{marginTop: '5vh', display:'block'}} size='large' />
     :
      <Row gutter={16} justify="center" >
        {filteredRequests?.length > 0 ? (
          filteredRequests?.sort((a, b) => b.time - a.time)?.map((request) => (
            <Col key={request.id} style={{ margin: '30px' }} >
              <Card
                hoverable
                style={{ width: 240, borderRadius: '8px' }}
                cover={
                  // <img
                  //   alt={request.artistName}
                  //   src={request.personalPic?.url || 'https://via.placeholder.com/150'}
                  //   style={{ width: '100%', borderRadius: '8px' }}
                  // />
                  <ProgressiveImage
                    // alt={request.artistName}
                    // src={request.personalPic?.url || 'https://via.placeholder.com/150'}
                    // style={{ width: '100%', borderRadius: '8px' }}

                    src={request.personalPic?.url}
                    alt={request.artistName}
                    key={request.id}
                    preview={false}
                    aspectRatio={1}
                  />
                }
                onClick={() => openModal(request)}
              >
                <Card.Meta
                  avatar={<UserOutlined />}
                  title={request.artistName}
                  description={
                    <div>

                    <p>{dayjs(request.time).format('DD-MMM-YYYY')}</p>
                    {request.status?.charAt(0).toUpperCase() + request.status?.slice(1)}
                    </div>
                  }
                />
                {/* <Button
                  type="default"
                  onClick={() => openModal(request)}
                  style={{ marginTop: '10px', width: '100%' }}
                >
                  View Request
                </Button> */}
              </Card>
            </Col>
          ))
        ) : (
          <Text level={2} style={{  fontWeight: '500' }}>No requests found in {filter?.charAt(0).toUpperCase() + filter?.slice(1)}</Text>
        )}
      </Row>
}

      {/* Modal to View/Approve/Reject Request */}
      <Modal
        title={`Request from ${selectedRequest?.artistName}`}
        visible={visible}
        onCancel={handleCancel}
        footer={null}
        width={800}
      >
        {selectedRequest && (
          <>
            {/* Profile Section */}
            <Row gutter={16}>
              <Col span={8} style={{ alignContent: 'center' }}>
                {/* <Card hoverable> */}
                <Image
                  alt="Profile"
                  src={selectedRequest.personalPic?.url || 'https://via.placeholder.com/150'}
                  style={{ width: '100%', borderRadius: '15px' }}
                />
                {/* </Card> */}
              </Col>
              <Col span={16}>
                <Card hoverable>
                  <div style={{ display: 'flex' }}>
                    <Text style={{ flex: 1 }} strong>Artist Name:</Text>
                    <Text style={{ flex: 1.5 }}>{selectedRequest.artistName}</Text>
                  </div>
                  {/* <Divider style={{marginTop:4,marginBottom:4}}/> */}
                  <div style={{ display: 'flex' }}>
                    <Text style={{ flex: 1 }} strong>City:</Text>
                    <Text style={{ flex: 1.5 }}>{selectedRequest.city}</Text>
                  </div>
                  {/* <Divider style={{marginTop:4,marginBottom:4}}/> */}
                  <div style={{ display: 'flex' }}>
                    <Text style={{ flex: 1 }} strong>Date of Birth:</Text>
                    <Text style={{ flex: 1.5 }}>{selectedRequest.dob}</Text>
                  </div>
                  {/* <Divider style={{marginTop:4,marginBottom:4}}/> */}
                  <div style={{ display: 'flex' }}>
                    <Text style={{ flex: 1 }} strong>Gender:</Text>
                    <Text style={{ flex: 1.5 }}>{selectedRequest.gender}</Text>
                  </div>
                  {/* <Divider style={{marginTop:4,marginBottom:4}}/> */}
                  <div style={{ display: 'flex' }}>
                    <Text style={{ flex: 1 }} strong>Nationality:</Text>
                    <Text style={{ flex: 1.5 }}>{selectedRequest.nationality}</Text>
                  </div>
                  {/* <Divider style={{marginTop:4,marginBottom:4}}/> */}
                  <div style={{ display: 'flex' }}>
                    <Text style={{ flex: 1 }} strong>Phone:</Text>
                    <Text style={{ flex: 1.5 }}>{selectedRequest.phoneNumber}</Text>
                  </div>
                  {/* <Divider style={{marginTop:4,marginBottom:4}}/> */}
                  <div style={{ display: 'flex' }}>
                    <Text style={{ flex: 1 }} strong>Social Media:</Text>
                    <Text style={{ flex: 1.5 }}>{selectedRequest.socialMedia}</Text>
                  </div>
                  {/* <Divider style={{marginTop:4,marginBottom:4}}/> */}
                  <div style={{ display: 'flex' }}>
                    <Text style={{ flex: 1 }} strong>Artist Bio:</Text>
                    <Text style={{ flex: 1.5 }}>{selectedRequest.artistBio}</Text>
                  </div>
                  {/* <Divider style={{marginTop:4,marginBottom:4}}/> */}
                  <div style={{ display: 'flex' }}>
                    <Text style={{ flex: 1 }} strong>Why Music:</Text>
                    <Text style={{ flex: 1.5 }}>{selectedRequest.whyMusic}</Text>
                  </div>

                </Card>
              </Col>
            </Row>

            {/* Media Section */}
            {
              selectedRequest.mediaFiles?.length > 0 &&
              <div style={{ marginTop: '20px' }}>
                <Text strong>Media Files:</Text>
                <Row gutter={16} style={{ flexDirection: 'column' }}>
                  {selectedRequest.mediaFiles?.map((file, index) => (
                    <Row key={index}>
                      <Card style={{ width: '100%', marginBottom: 10 }} bodyStyle={{ padding: '10px' }} hoverable>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                          <Text >{file.description}</Text>
                          {/* <br /> */}
                          <div style={{ alignContent: 'center', textAlign: 'center' }}>
                            <Button type="primary" onClick={() => handlePlayMedia(file.url, file.type)}>
                              Play {file.type === 'audio' ? 'Audio' : (file.type === 'video' ? 'Video' : '')}
                            </Button>
                            <Button type="link" onClick={() => handleDownloadMedia(file)} style={{ marginLeft: '10px' }}>
                              Download
                            </Button>
                          </div>
                        </div>

                      </Card>
                    </Row>
                  ))}
                </Row>
              </div>
            }
            {/* Recordings Section */}
            {
              selectedRequest.recordings?.length > 0 &&
              <div style={{ marginTop: '20px' }}>
                <Text strong>Recordings:</Text>
                <Row gutter={16} style={{ flexDirection: 'column' }}>
                  {selectedRequest.recordings?.map((file, index) => (
                    <Row key={index}>
                      <Card style={{ width: '100%', marginBottom: 10 }} bodyStyle={{ padding: '10px' }} hoverable>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>

                          <Text>{file.description}</Text>
                          {/* <br /> */}
                          <div style={{ alignContent: 'center', textAlign: 'center' }}>

                            <Button type="primary" onClick={() => handlePlayRecording(file.url)}>
                              Play Acapella
                            </Button>
                            <Button type="link" onClick={() => handleDownloadRecording(file)} style={{ marginLeft: '10px' }}>
                              Download
                            </Button>
                          </div>
                        </div>

                      </Card>
                    </Row>
                  ))}
                </Row>
              </div>
            }
            {/* Approve/Reject Buttons */}
            <div style={{ marginTop: '20px', justifySelf: 'end' }}>
              {
                (selectedRequest.status === 'new' || selectedRequest.status === 'rejected') &&
                <Button type="primary" onClick={handleApprove} style={{ marginRight: '10px' }}>
                  Approve
                </Button>
              }
              {
                (selectedRequest.status === 'new' || selectedRequest.status === 'approved') &&
                <Button type="danger" onClick={handleReject}>
                  Reject
                </Button>
              }
            </div>
          </>
        )}
      </Modal>
    </div>
  );
};

export default TalentSearchRequests;
